import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Phone, Mail, Menu, X, ChevronDown } from 'lucide-react';
import { companyInfo } from '../data/mockData';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isFormationsOpen, setIsFormationsOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <>
      {/* Top Bar */}
      <div className="bg-gray-900 text-white py-2 px-4">
        <div className="container mx-auto flex flex-wrap justify-end gap-4 text-sm">
          <a href={`tel:${companyInfo.phone.replace(/\s/g, '')}`} className="flex items-center gap-2 hover:text-red-500 transition-colors">
            <Phone size={16} />
            {companyInfo.phone}
          </a>
          <a href={`mailto:${companyInfo.email}`} className="flex items-center gap-2 hover:text-red-500 transition-colors">
            <Mail size={16} />
            Contactez-nous
          </a>
        </div>
      </div>

      {/* Main Navigation */}
      <nav className="bg-white shadow-md sticky top-0 z-50">
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between h-20">
            {/* Logo */}
            <Link to="/" className="flex items-center gap-3 hover:opacity-80 transition-opacity">
              <img 
                src={companyInfo.logo} 
                alt={companyInfo.name} 
                className="h-16 w-auto"
              />
              <div className="flex flex-col">
                <span className="text-2xl font-bold text-gray-900 tracking-tight leading-tight">FORMATION</span>
                <span className="text-2xl font-bold text-gray-900 tracking-tight leading-tight">DU DRAGON</span>
              </div>
            </Link>

            {/* Desktop Menu */}
            <div className="hidden lg:flex items-center gap-8">
              <Link 
                to="/" 
                className={`text-gray-700 hover:text-red-600 transition-colors font-medium ${
                  isActive('/') ? 'text-red-600' : ''
                }`}
              >
                Accueil
              </Link>
              
              <Link 
                to="/prestations" 
                className={`text-gray-700 hover:text-red-600 transition-colors font-medium ${
                  isActive('/prestations') ? 'text-red-600' : ''
                }`}
              >
                Prestations
              </Link>
              
              <Link 
                to="/formations" 
                className={`text-gray-700 hover:text-red-600 transition-colors font-medium ${
                  isActive('/formations') ? 'text-red-600' : ''
                }`}
              >
                Formations
              </Link>

              <Link 
                to="/calendrier" 
                className={`text-gray-700 hover:text-red-600 transition-colors font-medium ${
                  isActive('/calendrier') ? 'text-red-600' : ''
                }`}
              >
                Calendrier
              </Link>

              <Link 
                to="/contact" 
                className={`text-gray-700 hover:text-red-600 transition-colors font-medium ${
                  isActive('/contact') ? 'text-red-600' : ''
                }`}
              >
                Contact
              </Link>

              <Link 
                to="/contact" 
                className="bg-red-600 text-white px-6 py-2.5 rounded-md hover:bg-red-700 transition-colors font-semibold"
              >
                DEMANDEZ UN DEVIS
              </Link>
            </div>

            {/* Mobile Menu Button */}
            <button 
              className="lg:hidden text-gray-700 hover:text-red-600 transition-colors"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>

          {/* Mobile Menu */}
          {isMenuOpen && (
            <div className="lg:hidden py-4 border-t border-gray-100">
              <Link 
                to="/" 
                className="block py-3 text-gray-700 hover:text-red-600 transition-colors font-medium"
                onClick={() => setIsMenuOpen(false)}
              >
                Accueil
              </Link>
              <Link 
                to="/prestations" 
                className="block py-3 text-gray-700 hover:text-red-600 transition-colors font-medium"
                onClick={() => setIsMenuOpen(false)}
              >
                Prestations
              </Link>
              <Link 
                to="/formations" 
                className="block py-3 text-gray-700 hover:text-red-600 transition-colors font-medium"
                onClick={() => setIsMenuOpen(false)}
              >
                Formations
              </Link>
              <Link 
                to="/calendrier" 
                className="block py-3 text-gray-700 hover:text-red-600 transition-colors font-medium"
                onClick={() => setIsMenuOpen(false)}
              >
                Calendrier
              </Link>
              <Link 
                to="/contact" 
                className="block py-3 text-gray-700 hover:text-red-600 transition-colors font-medium"
                onClick={() => setIsMenuOpen(false)}
              >
                Contact
              </Link>
              <Link 
                to="/contact" 
                className="block mt-4 bg-red-600 text-white px-6 py-3 rounded-md hover:bg-red-700 transition-colors font-semibold text-center"
                onClick={() => setIsMenuOpen(false)}
              >
                DEMANDEZ UN DEVIS
              </Link>
            </div>
          )}
        </div>
      </nav>
    </>
  );
};

export default Navbar;